import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import cn from 'classnames';
import b from 'b_';
import ChangePasswordStore from '../../stores/ChangePasswordStore';
import ConsoleStore from '../../stores/ConsoleStore';
import SnackStore from '../../stores/SnackStore';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import FuseButton from '../FuseControls/FuseButton';
import { Card } from '../Fuse';
import FuseTextfield from '../FuseControls/FuseTextfield';
import { fetchDisplayRoleName } from '../../stores/Administrators/AdministratorModalStore';
import { FTBody, FTLabel } from '../Fuse/Text';
import FlagStore from '../../stores/FlagStore';
import './ChangePasswordModal.css';

const block = b.lock('ChangePasswordModal');


/**
 * @property {ChangePasswordStore} props.changePassword
 */
class
ChangePasswordModal extends Component {
    static propTypes = {
        changePassword: ChangePasswordStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    state = {
        currentPasswordVisibility: new FlagStore(false),
        newPasswordVisibility: new FlagStore(false),
        confirmPasswordVisibility: new FlagStore(false),
    };

    componentDidMount() {
        this.props.changePassword.setOnSuccess(() => this.props.snack.showSnack({
            type: 'success',
            content: `The password for "${this.props.console.userEmail}" has been successfully changed.`,
        }));
    }

    componentWillUnmount() {
        this.props.changePassword.setOnSuccess(null);
    }

    onSubmit = (event) => {
        event.preventDefault();
        this.props.changePassword.submit();
    };

    getPasswordError() {
        if (!this.props.changePassword.password.isTouched && this.props.changePassword.apiSubmitState.isFailed) {
            return 'Your current password is incorrect';
        }
        return '';
    }

    getNewPasswordError() {
        const { newPassword, newPasswordConfirmed, minPasswordLength } = this.props.changePassword;
        if (!newPassword.isTouched && !newPasswordConfirmed.isTouched &&
            (!newPassword.isValid || !newPasswordConfirmed.isValid)) {
            return `Passwords must match and be longer than ${minPasswordLength} characters.`;
        }
        return '';
    }

    render() {
        const { changePassword, console } = this.props;
        const { currentPasswordVisibility, newPasswordVisibility, confirmPasswordVisibility } = this.state;
        const { userEmail, firstName, lastName, authority } = console;
        const passwordError = this.getPasswordError();
        const newPasswordError = this.getNewPasswordError();

        return <FuseConsoleModal
            isOpen={changePassword.modal.isOpen}
            onClose={changePassword.modal.close}
            title="Change Password"
            subTitle={' - Administrator'}
            className={block()}
            headerActions={<FuseButton
                primary
                onClick={this.onSubmit}
                loading={changePassword.apiSubmitState.isLoading}
                disabled={!changePassword.canSubmit}
                color={'green'}
                style={{ minWidth: 100 }}
            >Save</FuseButton>}
        >

            <Card title="Change Password" className={block('Content')}>
                <form>
                    <FuseTextfield
                        className={block('TextField')}
                        label="Current Password"
                        placeholder="Enter current password"
                        autoComplete="current-password"
                        error={!!passwordError}
                        bottomText={passwordError}
                        store={changePassword.password}
                        rightIcon={currentPasswordVisibility.isTrue ? 'visibility_off' : 'visibility'}
                        rightIconClassName={block('VisibilityIcon')}
                        onRightIconClick={currentPasswordVisibility.toggle}
                        type={currentPasswordVisibility.isTrue ? 'text' : 'password'}
                        required
                        showRequired
                    />

                    <FuseTextfield
                        className={block('TextField')}
                        label="New Password"
                        placeholder="Enter new password"
                        autoComplete="new-password"
                        error={!!newPasswordError}
                        bottomText={newPasswordError}
                        store={changePassword.newPassword}
                        rightIcon={newPasswordVisibility.isTrue ? 'visibility_off' : 'visibility'}
                        rightIconClassName={block('VisibilityIcon')}
                        onRightIconClick={newPasswordVisibility.toggle}
                        type={newPasswordVisibility.isTrue ? 'text' : 'password'}
                        required
                        showRequired
                    />

                    <FuseTextfield
                        className={block('TextField')}
                        label="Confirm New Password"
                        placeholder="Enter new password"
                        autoComplete="new-password"
                        error={!!newPasswordError}
                        bottomText={newPasswordError}
                        store={changePassword.newPasswordConfirmed}
                        rightIcon={confirmPasswordVisibility.isTrue ? 'visibility_off' : 'visibility'}
                        rightIconClassName={block('VisibilityIcon')}
                        onRightIconClick={confirmPasswordVisibility.toggle}
                        type={confirmPasswordVisibility.isTrue ? 'text' : 'password'}
                        required
                        showRequired
                    />
                </form>
            </Card>

            <Card title="Summary" className={block('Content')}>
                <div className={cn(block('TextField'), block('SummaryTextField'))}>
                    <FTLabel className={block('SummaryTextFieldLabel')}>Email</FTLabel>
                    <FTBody>{userEmail || '--'}</FTBody>
                </div>

                <div className={cn(block('TextField'), block('SummaryTextField'))}>
                    <FTLabel className={block('SummaryTextFieldLabel')}>First Name</FTLabel>
                    <FTBody>{firstName || '--'}</FTBody>
                </div>

                <div className={cn(block('TextField'), block('SummaryTextField'))}>
                    <FTLabel className={block('SummaryTextFieldLabel')}>Last Name</FTLabel>
                    <FTBody>{lastName || '--'}</FTBody>
                </div>

                <div className={cn(block('TextField'), block('SummaryTextField'))}>
                    <FTLabel className={block('SummaryTextFieldLabel')}>Role</FTLabel>
                    <FTBody>{fetchDisplayRoleName(authority) || '--'}</FTBody>
                </div>
            </Card>
        </FuseConsoleModal>;
    }
}

export default inject('changePassword', 'console', 'snack')(observer(ChangePasswordModal));

